import React, { useState } from "react";
import "./ContactForm.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    Message: "",
  });
  const [submitMessage, setSubmitMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const scriptURL =
      "https://script.google.com/macros/s/AKfycbxrdqUDIVns0po7HGyAyTslEofskNG6iec9AF109f2vGvkcfas6FDX1PmzYmumPd6SDzA/exec";

    fetch(scriptURL, {
      method: "POST",
      body: new FormData(e.target),
    })
      .then((response) => {
        setSubmitMessage("Message Sent Successfully!");
        setTimeout(() => {
          setSubmitMessage("");
        }, 3000);
        setFormData({ Name: "", Email: "", Message: "" });
      })
      .catch((error) => console.error("Error!", error.message));
  };

  return (
    <>
      <form
        name="submit-to-google-sheet"
        className="contact-form"
        onSubmit={handleSubmit}
      >
        {/* Name */}
        <div className="form-group position-relative">
          <label htmlFor="formName" className="d-block">
            <i className="icon" data-feather="user"></i>
          </label>
          <input
            type="text"
            name="Name"
            id="formName"
            className="form-control form-control-lg thick"
            placeholder="Name"
            required
            value={formData.Name}
            onChange={handleChange}
          />
        </div>

        {/* Email */}
        <div className="form-group position-relative">
          <label htmlFor="formEmail" className="d-block">
            <i className="icon" data-feather="mail"></i>
          </label>
          <input
            type="email"
            name="Email"
            id="formEmail"
            className="form-control form-control-lg thick"
            placeholder="E-mail"
            required
            value={formData.Email}
            onChange={handleChange}
          />
        </div>

        {/* Message */}
        <div className="form-group message">
          <textarea
            name="Message"
            id="formMessage"
            className="form-control form-control-lg"
            rows="7"
            placeholder="Message"
            required
            value={formData.Message}
            onChange={handleChange}
          ></textarea>
        </div>

        {submitMessage && <p className="submit-message">{submitMessage}</p>}

        <div className="text-center">
          <button type="submit" className="btn btn-primary">
            Send message
          </button>
        </div>
      </form>
    </>
  );
};

export default ContactForm;
